import { css } from 'lit-element';

export const styles = css`
  :host {
    display: flex;
    height: 100%;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    container-name: single-post;
    box-sizing: border-box;
  }

  .card,
  .card-noimage {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 0;
    gap: 1.3rem;
  }

  .card-image_container {
    width: 100%;
  }

  .card-img_container img {
    width: 100%;
    display: block;
    margin: 0 auto;
    height: 13.125rem;
    object-fit: cover;
    border-radius: 0.5rem;
  }

  .card-background {
    border-radius: 0.5rem;
    margin: 0 auto;
    display: block;
    height: 150px;
    width: 100%;
    background-color: pink;
  }

  .btn {
    text-decoration: none;
    color: #fafafa;
    font-family: var(--headings-font-family);
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 900;
    line-height: 120%;
    letter-spacing: -0.0225rem;
    display: inline-block;
    padding: 1.125rem 2rem;
    background-color: #4b883c;
    border-radius: 0.5rem;
    transition: 300ms ease-in-out;
  }
  .btn:hover {
    color: #ffffff;
    background-color: #3c6930;
  }

  .loading {
    background-color: transparent;
    border-radius: 1.875rem;
    height: 100%;
    width: 100%;
    display: block;
    position: relative;
  }

  h2 {
    font-family: var(--headings-font-family);
    font-size: 1.1875rem;
    color: #1c1e1d;
    margin: 0;
    font-style: normal;
    font-weight: 900;
    line-height: 120%; /* 1.425rem */
    letter-spacing: -0.02375rem;
    margin-bottom: 0.5rem;
  }
  .card-content_description {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 2.6rem;
  }
  .card-content_description p {
    margin: 0;
    font-family: var(--body-font-family);
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0.01125rem;
  }

  @media screen and (min-width: 768px) {
    h2 {
      font-size: 1.5rem;
    }
    .card-img_container img {
      height: 26.5rem;
    }
    .card-content_description {
      gap: 2rem;
    }
  }

  @container single-post (width<200px) {
  }
`;
